export const ICON_SPRITE_URL = bmel.iconSpriteUrl || '/icons/icons.svg';
export const LANG = document.documentElement.lang || 'de';
export const BREAKPOINTS = {
  s: '0px',
  m: '510px',
  l: '865px',
  xl: '1190px',
  xxl: '1440px',
};



// WEBPACK FOOTER //
// ./src/javascripts/constants/index.js